import { MensajesGenericos_ES } from './Genericos/DiccionarioMensajesGenericos_ES';

const Diccionario_ES = [
    {
        'codigo': 'ErrorActualizarClave',
        'mensaje': 'Se presentaron problemas al realizar la recuperación de contraseña'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'El campo contraseña está vacío'
    },
    {
        'codigo': 'ErrorEmailNotFound',
        'mensaje': 'No se encontró la cuenta de correo electrónico'
    },
    {
        'codigo': 'ErrorEstLogin',
        'mensaje': 'Se presentaron problemas al iniciar sesión'
    },
    {
        'codigo': 'ErrorGetingDefaultCompany',
        'mensaje': 'Se presentaron problemas al obtener los datos de la compañía'
    },
    {
        'codigo': 'ErrorGetingDefaultCompanyDB',
        'mensaje': 'Se presentaron problemas al obtener los datos de la compañía'
    },
    {
        'codigo': 'ErrorProfLogin',
        'mensaje': 'Se presentaron problemas al iniciar sesión'
    },
    {
        'codigo': 'ErrorUserUnauthorized',
        'mensaje': 'El usuario no se encuentra autorizado, revise sus credenciales'
    },
    {
        'codigo': 'UnauthorizedPass',
        'mensaje': 'El usuario no se encuentra autorizado, revise sus credenciales'
    },
    {
        'codigo': 'UnauthorizedUser',
        'mensaje': 'El usuario no se encuentra autorizado, revise sus credenciales'
    },
    {
        'codigo': 'UserWithoutRoles',
        'mensaje': 'El usuario no tiene permisos definidos'
    },
    {
        'codigo': 'ErrorConfirmPassw',
        'mensaje': 'Se presentaron problemas al realizar la recuperación de contraseña'
    },
    {
        'codigo': 'ChangePasswOK',
        'mensaje': 'Cambio de contraseña realizado correctamente'
    },
    {
        'codigo': 'ErrorEmailVacio',
        'mensaje': 'El campo usuario está vacío'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'El campo contraseña está vacío'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'Formato de archivo (extensión) no permitido.'
    },
    {
        'codigo': 'ErrorUserEmpty',
        'mensaje': 'Debe ingresar su usuario.'
    },
    {
        'codigo': 'NoFileRules',
        'mensaje': 'El archivo no cumple con las reglas de configuracion.'
    },
    {
        "codigo": "UnauthorizedAccess",
        "mensaje": "Acceso denegado. No hay permisos para escribir archivos."
    },
    {
        "codigo": "FileInUseOrIOError",
        "mensaje": "El archivo está en uso o ocurrió un error de E/S al acceder a él."
    },
    {
        "codigo": "InsufficientDiskSpace",
        "mensaje": "La operación falló debido a espacio insuficiente en disco. Libere almacenamiento e intente nuevamente."
    },
    {
        "codigo": "UnknownError",
        "mensaje": "Ocurrió un error inesperado."
    }
];

export const DiccionarioMensajes_ES = [...MensajesGenericos_ES, ...Diccionario_ES];